<template>
  <div>
    <el-button
      v-if="modelo === 'flat'"
      type="primary"
      size="mini"
      @click="confirmarConsulta"
      class="__btn_confirmar_presenca"
    >
      <i class="el-icon el-icon-check"></i> CONFIRMAR
    </el-button>
    <template v-if="confirmed">
      <el-button
        v-if="modelo === 'switch'"
        size="mini"
        class="__btn_confirmar_presenca__switch --confirmed"
      >
        <div class="body">
          <i class="el-icon el-icon-circle-check"></i>
          <span>PRESENÇA CONFIRMADA</span>
        </div>
      </el-button>
    </template>
    <template v-else>
      <el-button
        v-if="modelo === 'switch'"
        size="mini"
        @click="confirmarConsulta"
        class="__btn_confirmar_presenca__switch --not-confirmed"
      >
        <div class="body">
          <i class="el-icon el-icon-circle-check"></i>
          <span>CONFIRMAR PRESENÇA</span>
        </div>
      </el-button>
    </template>
  </div>
</template>
<script>

export default {
  name: 'ConfirmarConsultaBtn',
  props: {
    modelo: {
      type: String,
      default: 'flat'
    },
    confirmed: {
      type: Boolean,
      default: false
    },
    confirmarConsulta: {
      type: Function,
      required: true
    }
  }
}

</script>
<style lang="less" scoped>
.__btn_confirmar_presenca {
  background-color: #1B8BD9;
  border-color: #00A0E4;
  font: normal normal 600 11px/15px Open Sans;
  color: #FFFFFF;
  text-transform: uppercase;
  padding: 7px 12px;
  height: 29px;
  border-radius: 5px;
}
.__btn_confirmar_presenca__switch {
  font: normal normal 600 11px/15px Open Sans;
  text-transform: uppercase;
  padding: 7px 12px;
  height: 54px;
  border-radius: 5px;
  width: 163px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-style: solid;
  border-width: 1px;
  &.--not-confirmed {
    background-color: #1B8BD9;
    color: #FFFFFF;
    border-color: #1B8BD9;
  }
  &.--confirmed {
    background-color: #FFFFFF;
    color: #1B8BD9;
    border-color: #1B8BD9;
  }
  .body {
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: break-spaces;

    i {
      font-size: 28px;
    }

    span {
      text-align: left;
      font: normal normal 600 12px/17px Open Sans;
      letter-spacing: 0px;
      text-transform: uppercase;
      word-wrap: break-word;
    }
  }
}

</style>
